import { type SurveyQuestionType } from '../../../../models/Survey'
import { type ISurveySection, type IOption } from '../../../../models/SurveyTemplate'

export enum Answers {
  UNANSWERED = 'unanswered',
  ANY = 'ANY'
}

export enum BranchingOperation {
  IS = 'is',
  IS_EMPTY = 'unanswered',
  IS_NOT_EMPTY = 'answered'
}

export interface SectionMap {
  sectionId: string
  items: SectionItem[]
  parentSectionId?: string
  origin?: Pick<SectionOrigin, 'itemId'>
  step: number | null
}

export interface SectionOrigin {
  itemId: string
  operation: BranchingOperation
  type: SurveyQuestionType
}

export interface SectionBranch {
  branchingValue: string | Answers
  sectionId: ISection['surveySectionId']
  branchType: SurveyQuestionType
}

export interface SectionItem {
  itemId: string
  itemType: SurveyQuestionType
  value: string
  prompt: string
  object: string[] | IOption[] | null
  isRequired: boolean
  branches: SectionBranch[]
  revision: number
}

export interface ISection {
  surveySectionId: string
  parentSurveySectionId: string | undefined
  instructorId: string | undefined
  instructorName: string | null
  title: string | null
  descr: string | null
  surveyItems: SectionItem[]
  origin?: SectionOrigin
  children: ISection[]
}

export type HandleChangeFn = (value: string | string[], section: ISection['surveySectionId'], itemId: string) => void
export type HandleBackFn = () => void
export type HandleNextFn = () => void
export type ShouldRenderSectionFn = (root: ISection, section: ISection) => boolean
export type RenderedSectionsRef = React.MutableRefObject<Map<string, boolean>>

export interface UseSurveyFeatureStepperReturnValue {
  sections: ISection[]
  renderedSectionsRef: RenderedSectionsRef
  invalidItemIDs: string[]
  handleChange: HandleChangeFn
  handleBack: HandleBackFn
  handleNext: HandleNextFn
  shouldRenderSection: ShouldRenderSectionFn
  triggerPulse: boolean
}

export interface SectionResponseItem {
  answer: string | string[]
  itemId: SectionItem['itemId']
  revision: SectionItem['revision']
  instructorId: ISection['instructorId']
  surveySectionId: ISection['surveySectionId']
  surveySectionRevision: ISurveySection['surveySectionRevision']
}

export type OnSubmitFn = (responseItems: SectionResponseItem[]) => Promise<any>
